// Tiny event bus so the (non-React) response handler can signal the UI that the
// session ended (401 — token expired/revoked) before it sends the user back to
// the login flow. Mirrors upgradeBus.ts.
const EVENT = 'bq:session-expired'

export const emitSessionExpired = () => window.dispatchEvent(new CustomEvent(EVENT))

export const onSessionExpired = (cb: () => void) => {
    const handler = () => cb()
    window.addEventListener(EVENT, handler)
    return () => window.removeEventListener(EVENT, handler)
}
